<template>
  <Layout>
    <SubHeader slot="sub-header"
      :title="$t('common.detail')"
      :isBackground="false" />
    <div slot="body" class="cat-card-view">
      <LoadingBounce v-if="busy" />
      <template v-else>
        <div class="row m-0 mt-14">
          <div class="col-lg-3 col-md-3 col-sm-4 col-6 p-0">
            <ImageCard :cardLecture="cardLecture"
              :isCourseCard="isCourseCard"
              :courseId="courseId"
              :likeCount="cardLikeCount" />
          </div>
          <div class="col-lg-9 col-md-9 col-sm-8 col-6 p-0 card-container">

            <div class="card-title">
              {{ cardTitle }}
            </div>

            <div class="card-publisher">
              {{ publisherName }}
            </div>

            <div class="card-subject">
              {{ cardGrade }}
              {{ cardSubjectName }}
            </div>

            <div class="card-page-count">
              {{ cardPageCount || 0 }} {{ $t('card_lecture.page_count') }}
            </div>

            <div class="card-action-container">
              <button class="cl-btn-lg" @click="moveCardViewer()">{{ $t('common.learning') }}</button>
            </div>

          </div>
        </div>

        <div class="card-action-sub-container">
          <button class="cl-btn-lg" @click="moveCardViewer()">{{ $t('common.learning') }}</button>
        </div>

        <div class="card-description" v-html="cardGoal"></div>

        <div class="card-created-date">
          {{ $t('common.created_date') }} {{ cardCreatedDate }}
        </div>

        <div class="card-actions">
          <a @click="toggleLike()" :class="[ isLikeCardLecture ? 'active' : '']">
            <img class="icon" :src="`/static/images/ic_post_light${isLikeCardLecture ? '_active' : '_normal'}.svg`" />
            {{ $t('common.like_up') }}
          </a>
          <a @click="toggleBookmark()" :class="[ isBookmarkCardLecture ? 'active' : '']">
            <img class="icon" :src="`/static/images/ic_bookmark${isBookmarkCardLecture ? '_active' : ''}.svg`" />
            {{ $t('common.bookmark') }}
          </a>
        </div>

        <div class="card-course" v-if="isCardCourse">
          <CourseCard :course="cardCourse" @click="viewCourse(cardCourse.id)" />
        </div>

        <div class="card-relation">
          <div class="row align-items-center header">
            <div class="col-8 title"> {{ isCourseCard ? $t('course.card_lecture') : $t('card_lecture.relation_card_lecture') }}</div>
            <div class="col-4 action"></div>
          </div>

          <div class="row px-8">
            <div class="col-lg-3 col-md-3 col-sm-6 col-6 px-6 mb-2 mt-6"
              v-for="(item, index) in cardLectures" :key="index">
              <ImageCard :cardLecture="item"
                :isCurrentCard="isCurrentCard(item.id)"
                :isCourseCard="isCourseCard"
                :courseId="courseId" />
            </div>
            <InfiniteLoading v-if="cardLectures.length >= 10" @infinite="infiniteHandler" class="w-100">
              <div slot="spinner">
                <LoadingBounce></LoadingBounce>
              </div>
              <span slot="no-results"></span>
              <span slot="no-more"></span>
            </InfiniteLoading>
          </div>
        </div>

      </template>

      <PrimeSnackBar v-if="isSnackBar"
        @okSnackBar="okSnackBar()"
        @closeSnackBar="closeSnackBar()" />

    </div>
  </Layout>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import moment from 'moment/src/moment';
  import InfiniteLoading from 'vue-infinite-loading';
  import { find, isEmpty, has } from 'lodash';
  import { CT_VIEWER_URL, CLASSTING_PAY_WEB } from '@/config';
  import labels from '@/mixins/labels';

  export default {
    name: 'card-lecture-view',

    data() {
      return {
        busy: false,
        cardLecture: {},
        cardLectures: {},
        cardCourse: {},
        isLikeCardLecture: false,
        isBookmarkCardLecture: false,
        isCourseSubscribed: false,
        isSnackBar: false,
        cardLikeCount: 0,
        page: 1,
        limit: 10,
      };
    },

    mixins: [
      labels,
    ],

    components: {
      InfiniteLoading,
    },

    computed: {
      ...mapGetters({
        routeParams: 'getRouteParams',
        routeQuery: 'getRouteQuery',
        subjectMap: 'getSubjectMap',
        gradeMap: 'getGradeMap',
        currentUserId: 'currentUserId',
        isPrime: 'isPrime',
        isUserLicence: 'isUserLicence',
        isPremiumSchool: 'isPremiumSchool',
        isSubscriptionUser: 'isSubscriptionUser',
        isPrimeSupportCountry: 'isPrimeSupportCountry',
      }),

      cardId() {
        return this.cardLecture && this.cardLecture.id;
      },

      cardTitle() {
        return this.cardLecture && this.cardLecture.title;
      },

      cardPublisher() {
        return this.cardLecture && this.cardLecture.owner;
      },

      publisherName() {
        return this.cardPublisher && this.cardPublisher.name;
      },

      publisherId() {
        return this.cardPublisher && this.cardPublisher.id;
      },

      filterSubject() {
        return find(this.subjectMap, { id: this.cardLecture.subject_id }) || {};
      },

      cardSubjectName() {
        return this.filterSubject.name;
      },

      cardGrade() {
        return this.getTranslatedName(this.gradeMap[this.cardLecture.grade_id]);
      },

      cardPageCount() {
        return this.cardLecture && this.cardLecture.page_count;
      },

      cardGoal() {
        if (isEmpty(this.cardLecture && this.cardLecture.goal)) {
          return false;
        }
        return this.cardLecture && this.cardLecture.goal.replace(/\n/g, '<br>');
      },

      storeCardId() {
        return this.cardLecture && this.cardLecture.store_card_id;
      },

      cardCreatedDate() {
        return moment(this.cardLecture && this.cardLecture.created_at).format('YYYY.MM.DD');
      },

      isCourseCard() {
        if (has(this.routeQuery, 'course_id')) {
          return true;
        }

        return false;
      },

      courseId() {
        return Number(this.routeQuery.course_id);
      },

      cardLectureId() {
        return this.routeParams.cardId;
      },

      isCardCourse() {
        return !isEmpty(this.cardCourse);
      },
    },

    methods: {
      ...mapActions([
        'createCardLectureViews',
        'fetchCardLecture',
        'fetchSimilarCardLectures',
        'fetchCardLectures',
        'fetchCardLectureIsLiked',
        'fetchCardCourse',
        'fetchCardCourseIsSubscribed',
        'createCardLectureLike',
        'removeCardLectureLike',
        'fetchSubjects',
        'fetchCardLectureIsBookmarked',
        'createCardLectureBookmark',
        'removeCardLectureBookmark',
      ]),

      showPrime() {
        if (this.$mobile.isClasstingClient()) {
          return this.$mobile.openNewWebView(CLASSTING_PAY_WEB);
        }

        return window.open(CLASSTING_PAY_WEB);
      },

      okSnackBar() {
        this.$ga.event({
          eventCategory: 'prime',
          eventLabel: 'snackbar_card_lecture',
          eventAction: 'click',
        });

        this.isSnackBar = false;
        this.showPrime();
      },

      openSnackBar() {
        this.isSnackBar = true;
      },

      closeSnackBar() {
        this.isSnackBar = false;
      },

      setCardLectureEventCount(count) {
        return this.$localStorage.set('cardLectureEventCount', count);
      },

      getCardLectureEventCount() {
        return Number(this.$localStorage.get('cardLectureEventCount') || 0);
      },

      isCurrentCard(id) {
        return id === this.cardId;
      },

      viewCourse(courseId) {
        this.$ga.event({
          eventCategory: 'recommended_lectures',
          eventLabel: 'card_lecture.course',
          eventAction: 'click',
        });

        return this.$router.push({
          name: 'card-course-view',
          params: {
            courseId,
          },
        });
      },

      infiniteHandler($state) {
        this.page += 1;
        const filters = {
          page: this.page,
          per_page: this.limit,
        };

        Promise.resolve()
          .then(() => {
            if (this.isCourseCard) {
              filters.card_course_id = this.courseId;
              return this.fetchCardLectures(filters);
            }
            return this.fetchSimilarCardLectures({ filters, lectureId: this.cardLectureId });
          })
          .then((data) => {
            if (data.length > 0) {
              this.cardLectures = this.cardLectures.concat(data);
              return $state.loaded();
            }
            return $state.complete();
          });
      },

      moveCardViewer() {
        return window.open(`${CT_VIEWER_URL}/viewer/coin-cards/${this.storeCardId}`);
      },

      toggleLike() {
        if (!this.isLikeCardLecture) {
          this.$ga.event({
            eventCategory: 'recommended_lectures',
            eventLabel: 'card_lecture',
            eventAction: 'light_up',
          });

          return this.createCardLectureLike(this.cardLectureId)
            .then((isLikeCardLecture) => {
              this.isLikeCardLecture = isLikeCardLecture;
              this.cardLikeCount += 1;
            });
        }

        this.$ga.event({
          eventCategory: 'recommended_lectures',
          eventLabel: 'card_lecture',
          eventAction: 'unlit',
        });

        return this.removeCardLectureLike(this.cardLectureId)
          .then((isLikeCardLecture) => {
            this.isLikeCardLecture = isLikeCardLecture;
            this.cardLikeCount -= 1;
          });
      },

      toggleBookmark() {
        if (!this.isBookmarkCardLecture) {
          this.$ga.event({
            eventCategory: 'recommended_lectures',
            eventLabel: 'card_lecture',
            eventAction: 'bookmark',
          });

          return this.createCardLectureBookmark(this.cardLectureId)
            .then((isBookmarkCardLecture) => {
              this.isBookmarkCardLecture = isBookmarkCardLecture;
            });
        }

        this.$ga.event({
          eventCategory: 'recommended_lectures',
          eventLabel: 'card_lecture',
          eventAction: 'unbookmark',
        });

        return this.removeCardLectureBookmark(this.cardLectureId)
          .then((isBookmarkCardLecture) => {
            this.isBookmarkCardLecture = isBookmarkCardLecture;
          });
      },

      initCardLecture() {
        this.$route.meta.title = this.$t('common.detail');
        this.busy = true;
        Promise.resolve()
          .then(() => {
            if (isEmpty(this.subjectMap)) {
              return this.fetchSubjects();
            }
            return true;
          })
          .then(() => {
            this.fetchCardLecture(this.cardLectureId)
              .then((cardLecture) => {
                this.cardLecture = cardLecture;
                this.cardLikeCount = cardLecture.like_count;
                if (cardLecture.card_course_id) {
                  return this.fetchCardCourse(cardLecture.card_course_id)
                    .then((cardCourse) => {
                      this.cardCourse = cardCourse;
                      this.fetchCardCourseIsSubscribed({
                        courseId: cardLecture.card_course_id,
                        userId: this.currentUserId,
                      })
                      .then((isCourseSubscribed) => {
                        this.isCourseSubscribed = isCourseSubscribed;
                      });
                    });
                }
                return true;
              });
          })
          .then(() => {
            const params = {
              owner_id: this.publisherId,
              is_prime: this.isPrime,
              is_user_licence: this.isUserLicence,
              is_school_licence: this.isPremiumSchool,
            };
            return this.createCardLectureViews({ lectureId: this.cardLectureId, params });
          })
          .then(() => (
            this.fetchCardLectureIsLiked({
              lectureId: this.cardLectureId,
              userId: this.currentUserId,
            })
            .then((isLikeCardLecture) => {
              this.isLikeCardLecture = isLikeCardLecture;
            })
          ))
          .then(() => (
            this.fetchCardLectureIsBookmarked({
              lectureId: this.cardLectureId,
              userId: this.currentUserId,
            })
            .then((isBookmarkCardLecture) => {
              this.isBookmarkCardLecture = isBookmarkCardLecture;
            })
          ))
          .then(() => {
            this.page = 1;
            const filters = {
              page: this.page,
              per_page: this.limit,
            };

            if (this.isCourseCard) {
              filters.card_course_id = this.courseId;
              return this.fetchCardLectures(filters);
            }

            return this.fetchSimilarCardLectures({ filters, lectureId: this.cardLectureId });
          })
          .then((cardLectures) => {
            this.cardLectures = cardLectures;
          })
          .then(() => (
            this.$ga.event({
              eventCategory: 'recommended_lectures',
              eventLabel: 'card_lecture_light',
              eventAction: 'view',
              eventValue: this.videoLikeCount,
            })
          ))
          .then(() => (
            this.$ga.event({
              eventCategory: 'recommended_lectures',
              eventLabel: 'card_lecture_view',
              eventAction: 'view',
              eventValue: this.videoLecture && this.videoLecture.view_count,
            })
          ))
          .then(() => {
            if (!this.isSubscriptionUser && !this.getCardLectureEventCount()) {
              return this.setCardLectureEventCount(1);
            }

            if (!this.isSubscriptionUser && this.getCardLectureEventCount()) {
              const eventCount = this.getCardLectureEventCount() + 1;
              return this.setCardLectureEventCount(eventCount);
            }

            return true;
          })
          .then(() => {
            if (!this.isSubscriptionUser &&
              this.isPrimeSupportCountry &&
              this.getCardLectureEventCount() >= 12) {
              this.$ga.event({
                eventCategory: 'prime',
                eventLabel: 'snackbar_card_lecture',
                eventAction: 'view',
              });
              this.$localStorage.set('cardLectureEventCount', 0);
              this.openSnackBar();
              return true;
            }
            return true;
          })
          .then(() => {
            this.busy = false;
          });
      },
    },

    beforeMount() {
      this.initCardLecture();
    },

    watch: {
      $route() {
        this.initCardLecture();
      },
    },
  };
</script>

<style lang="scss" scoped>
  $card-text-color: rgba(0, 0, 0, 0.54);

  .cat-card-view {
    max-width: 946px;
    margin: 0 auto;
    padding: 0px 14px 0px 14px;

    .card-container {
      position: relative;

      .card-title {
        margin: 6px 4px 14px 34px;
        font-size: 16px;
        font-weight: 500;
      }

      .card-publisher {
        font-size: 14px;
        font-weight: bold;
        margin: 0px 14px 4px 34px;
        color: rgba(0, 0, 0, 0.38);
      }

      .card-subject {
        font-size: 14px;
        font-weight: bold;
        margin: 0px 14px 0px 34px;
        color: rgba(0, 0, 0, 0.38);
      }

      .card-page-count {
        color: rgba(0, 0, 0, 0.38);
        margin: 0px 14px 0px 14px;
        font-size: 14px;
        position: absolute;
        bottom: 64px;
        right: 0px;
      }

      .card-action-container {
        width: 286px;
        position: absolute;
        bottom: 0;
        right: 0;

        @media (max-width: 576px) {
          display: none;
        }
      }
    }

    .card-action-sub-container {
      padding: 14px 0px 14px 0px;

      @media (min-width: 576px) {
        display: none;
      }
    }

    .card-description {
      padding: 24px 0px 24px 0px;
      color: rgba(0, 0, 0, 0.54);
    }

    .card-created-date {
      color: rgba(0, 0, 0, 0.54);
      padding-bottom: 14px;
      text-align: right;
    }

    .card-actions {
      text-align: right;
      padding-bottom: 24px;

      .active {
        color: #00c896;
        &:hover {
          color: #00c896;
        }
      }

      .icon {
        margin: 0px 4px 0px 4px;
        height: 20px;
        width: 20px;
      }

      a {
        display: inline-block;
        margin: 16px 0px 16px 32px;
        cursor: pointer;
        color: $card-text-color;

        &:hover {
          color: rgba(0, 0, 0, 0.6);
        }
      }
    }

    .card-course {
      padding-bottom: 44px;
    }

    .card-relation {

      .header {
        padding: 20px 14px 20px 14px;

        .title {
          font-size: 18px;
          padding: 0;

          strong {
            color: #00c896;
          }
        }
      
        .action {
          text-align: right;
        }
      }
    }

  }

</style>


// WEBPACK FOOTER //
// CardLectureView.vue?f69f72e2